import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper, CustomReactTable } from './styled';
import { Status } from '../Grid/components/UserAgents/components/UserAgent/styled';
import { useIntl } from 'react-intl';
import TimeAgo from 'react-timeago';
import Switch from 'react-switch';
import colors from 'Styles/colors';
import { SwitchContainer } from 'Screens/Contextualization/Workspaces/components/Table/styled';
import { CategoriesCell, CheckColum, CheckHeader, NameCell } from './components/columns';
import { selectIsAdmin } from 'store/Faraday/selectors';
import { changeStateAgent, setAgentsEntity, setOrderByUserAgents } from 'store/Agents/actions';
import { selectIsFetching } from 'store/Agents/selectors';
import Skeleton from 'Common/Components/Skeleton';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import { RUNNERS_ENTITY } from 'store/Agents/reducer';

const Table = ({ agents }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [agentsList, setAgentsList] = useState(agents);
  const isFetching = useSelector(selectIsFetching);
  const isAdmin = useSelector(selectIsAdmin);
  const show = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));

  const columns = [
    {
      Header: () => <CheckHeader disabled={ show } />,
      id: 'selected',
      accessor: 'selected',
      show: true,
      sortable: false,
      resizable: false,
      maxWidth: 55,
      minWidth: 55,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: ({ original }) => ((isFetching) ? <Skeleton /> : <CheckColum agent={ original } disabled={ show } />)
    },
    {
      Header: 'Name',
      accessor: 'name',
      id: 'name',
      show: true,
      sortable: true,
      Cell: ({ original }) => ((isFetching) ? <Skeleton /> : <NameCell agent={ original } />)
    },
    {
      Header: 'Status',
      accessor: 'status',
      id: 'status',
      show: true,
      sortable: false,
      maxWidth: 150,
      minWidth: 150,
      Cell: ({ value }) => {
        const statusLabel = value ? intl.formatMessage({ id: `agents.item.status.${value}` }) : 'Online';
        if (isFetching) return <Skeleton />;
        return <Status value={ value || 'online' } children={ statusLabel } noMargin />;
      }
    },
    {
      Header: 'Last Executed',
      accessor: 'last_run',
      id: 'last_run',
      show: true,
      sortable: false,
      Cell: ({ value }) => ((isFetching) ? <Skeleton /> : <TimeAgo date={ value } />)
    },
    {
      Header: 'Blocked',
      accessor: 'active',
      id: 'active',
      show: true,
      sortable: true,
      Cell: ({ original, value }) => (
        (isFetching)
          ? <Skeleton />
          : <SwitchContainer checked={ value }>
            <Switch
              checked={ !value }
              onChange={ () => { dispatch(changeStateAgent(original)); } }
              onColor={ colors.green4 }
              offColor={ colors.grey14 }
              onHandleColor={ colors.green3 }
              offHandleColor={ colors.grey15 }
              boxShadow="0 0 4px 0 rgba(83, 83, 83, 0.5)"
              activeBoxShadow=""
              height={ 14 }
              width={ 39 }
              handleDiameter={ 21 }
              uncheckedIcon={ false }
              checkedIcon={ false }
              disabled={ !isAdmin }
            />
            </SwitchContainer>
      )
    },
    {
      Header: 'Description',
      accessor: 'description',
      id: 'description',
      show: true,
      sortable: true,
      minWidth: 150,
      Cell: ({ value }) => ((isFetching) ? <Skeleton /> : <div style={ { color: '#90a9c0', fontSize: '14.5px' } }>{value}</div>)
    },
    {
      Header: 'Categories',
      accessor: 'category',
      id: 'category',
      show: true,
      sortable: false,
      minWidth: 150,
      Cell: ({ original }) => ((isFetching) ? <Skeleton /> : <CategoriesCell agent={ original } />)
    }
  ];

  const mockData = [...Array(13).keys()];

  useEffect(() => {
    setAgentsList(agents);
  }, [agents]);

  useEffect(() => {
    dispatch(setAgentsEntity(RUNNERS_ENTITY));
  }, [dispatch]);

  const fetchData = (tableState) => {
    if (!isFetching) {
      dispatch(setOrderByUserAgents(tableState.sorted));
    }
  };

  return (
      <Wrapper>
        <CustomReactTable
          data={ isFetching ? mockData : agentsList }
          columns={ columns }
          minRows={ 0 }
          manual
          showPagination={ false }
          onFetchData={ fetchData }
        />
      </Wrapper>
  );
};

export default Table;
